var _circle, _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1A3459"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(12 12)",
    fill: "#1A3459"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6005 14.1818H28.399C31.3871 14.1818 33.8181 16.6128 33.818 19.6007V28.3992C33.818 31.3871 31.3871 33.8181 28.399 33.8181H19.6005C16.6125 33.8181 14.1816 31.3872 14.1816 28.3992V19.6007C14.1816 16.6128 16.6125 14.1818 19.6005 14.1818ZM28.3991 32.0759C30.4265 32.0759 32.0759 30.4266 32.0759 28.3992H32.0758V19.6007C32.0758 17.5734 30.4263 15.924 28.399 15.924H19.6005C17.5732 15.924 15.9239 17.5734 15.9239 19.6007V28.3992C15.9239 30.4266 17.5732 32.076 19.6005 32.0759H28.3991ZM18.857 24.0001C18.857 21.1642 21.164 18.8571 23.9998 18.8571C26.8356 18.8571 29.1427 21.1642 29.1427 24.0001C29.1427 26.8358 26.8356 29.1428 23.9998 29.1428C21.164 29.1428 18.857 26.8358 18.857 24.0001ZM20.6278 23.9999C20.6278 25.8592 22.1406 27.3718 23.9998 27.3718C25.8591 27.3718 27.3718 25.8592 27.3718 23.9999C27.3718 22.1405 25.8592 20.6278 23.9998 20.6278C22.1404 20.6278 20.6278 22.1405 20.6278 23.9999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3317_21549",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6005 14.1818H28.399C31.3871 14.1818 33.8181 16.6128 33.818 19.6007V28.3992C33.818 31.3871 31.3871 33.8181 28.399 33.8181H19.6005C16.6125 33.8181 14.1816 31.3872 14.1816 28.3992V19.6007C14.1816 16.6128 16.6125 14.1818 19.6005 14.1818ZM28.3991 32.0759C30.4265 32.0759 32.0759 30.4266 32.0759 28.3992H32.0758V19.6007C32.0758 17.5734 30.4263 15.924 28.399 15.924H19.6005C17.5732 15.924 15.9239 17.5734 15.9239 19.6007V28.3992C15.9239 30.4266 17.5732 32.076 19.6005 32.0759H28.3991ZM18.857 24.0001C18.857 21.1642 21.164 18.8571 23.9998 18.8571C26.8356 18.8571 29.1427 21.1642 29.1427 24.0001C29.1427 26.8358 26.8356 29.1428 23.9998 29.1428C21.164 29.1428 18.857 26.8358 18.857 24.0001ZM20.6278 23.9999C20.6278 25.8592 22.1406 27.3718 23.9998 27.3718C25.8591 27.3718 27.3718 25.8592 27.3718 23.9999C27.3718 22.1405 25.8592 20.6278 23.9998 20.6278C22.1404 20.6278 20.6278 22.1405 20.6278 23.9999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3317_21549)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b1b0b40edfef5c3a5653b6c7b32964a2.svg";
export { ForwardRef as ReactComponent };